var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"disabled":_vm.state==='sending' || _vm.state==='done',"size":_vm.size,"variant":_vm.variant},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.state==='sending')?_c('b-spinner',{staticStyle:{"margin-right":".25rem"},attrs:{"small":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }